import { render, staticRenderFns } from "./selfpay.vue?vue&type=template&id=198cefc9&scoped=true&"
import script from "./selfpay.vue?vue&type=script&lang=js&"
export * from "./selfpay.vue?vue&type=script&lang=js&"
import style0 from "./selfpay.vue?vue&type=style&index=0&id=198cefc9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198cefc9",
  null
  
)

export default component.exports